<template>
  <v-row>
    <v-col cols="12">
      <v-toolbar color="white" flat>
        <v-toolbar-title class="grey--text text-h4 text--darken-4">
          Register
        </v-toolbar-title>
      </v-toolbar>
    </v-col>
    <v-col class="d-flex m-0 pb-0" cols="12" sm="4">
      <v-select
        clearable
        class="m-0"
        v-model="selectedAccount"
        :items="accounts"
        item-text="fname"
        label="Accounts"
        outlined
        return-object
      ></v-select>
    </v-col>
    <v-col class="d-flex m-0 pb-0" cols="12" sm="4">
      <v-select
        clearable
        v-model="selectedCounterparty"
        :items="counterparties"
        item-text="name"
        label="Counterparty"
        outlined
        return-object
      ></v-select>
    </v-col>
    <v-col class="m-0 pb-0" cols="12" sm="4">
      <date-range-picker @onDates="onDatesSelected"/>
    </v-col>    
    <v-col class="d-flex" cols="12" sm="4" offset-sm="8" v-if="registerEntries.length > 0">
      <v-card elevation="0">
        <v-card-title class="text-h6">
            {{registerBalance}}
        </v-card-title>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="formatedEntries"
        :items-per-page="10"
        item-key="id"
        class="elevation-3"
      >
      </v-data-table>
    </v-col>
  </v-row>
</template>
<style scoped>
</style>

<script>
import { Counterparty } from '@/model';
import DateRangePicker from './common/DateRangePicker.vue';
export default {
  components: { DateRangePicker },
  name: "Register",

  data() {
    return {
      selectedAccount: undefined,
      selectedCounterparty: undefined,
      selectedDates:[],
      headers: [
        { text: "Date", value: "date", align: "start" },
        { text: "Account", value: "account", align: "start" },
        { text: "Counterparty", value: "counterparty" },
        { text: "Amount", value: "amount", sortable: false, align: "end" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  computed: {
    accounts() {
      const accounts = this.$store.state.accounts;
      return accounts.sort((a, b) => a.fname.localeCompare(b.fname));
    },
    counterparties() {
      const counterparties = this.$store.state.counterparties;
      return Counterparty.sort(counterparties);
    },
    formatedEntries() {
      return this.registerEntries.length > 0 ? this.registerEntries.entries.map(this.formatValue) : [];
    },
    registerBalance() {
      if (this.registerEntries.length === 0) {
        return " ";
      }
      const amount = this.registerEntries.totalAmount;
      return amount ? this.$options.filters.formatAmount(amount) : " ";
    },
    registerEntries() {
      return this.filterRegisterEntries(this.selectedAccount, this.selectedCounterparty, this.selectedDates);
    },
  },
  methods: {
    formatValue(registerEntry) {
      return {
        id: registerEntry.uuid,
        date: this.$options.filters.formatDate(registerEntry.date),
        account: registerEntry.account.obj().fname,
        counterparty: registerEntry.counterparty.obj().name,
        amount: this.$options.filters.formatAmount(registerEntry.amount),
      };
    },
    onDatesSelected(dates) {
      this.selectedDates = dates.map(d => new Date(d));
    },
    filterRegisterEntries(account, counterparty, dates) {
      if (!account && !counterparty) {
        return [];
      }
      const registerEntries = this.$store.getters["filterRegisterEntries"](account, counterparty, dates);
      return registerEntries;
    },
  },
  async created() {
    await this.$store.dispatch("getAccounts");
    await this.$store.dispatch("getCounterparties");
    await this.$store.dispatch("getTransactions");
  },
};
</script>